export const TEXTS = {
  ru: {
    btnText: 'Обменять',
    labelWallet: 'Укажите адрес вашего кошелька:',
    btnNextText: 'Далее > ',
    inputPlaceholder: 'например',
    emptyInputAlert: 'укажите кошелек',
    labelSum: 'Укажите сумму для обмена:',
    inputPlaceholder2: 'например 2500, 5000 и т.д.',
    emptyInputAlert2: 'введите сумму',
    wrongSumAlert: 'сумма должна быть кратна 2500',
    notEnoughPointAlert: 'у вас не хватает баллов',
    textRqstSentToAdmin: 'Запрос на обмен отправлен администраторам',
  },
  en: {
    btnText: 'Change',
    labelWallet: 'Write down your wallet adress:',
    btnNextText: 'Next > ',
    inputPlaceholder: 'for example',
    emptyInputAlert: 'wallet adress is necessary',
    labelSum: 'Amount to be exchanged:',
    inputPlaceholder2: 'for example 2500, 5000 и т.д.',
    emptyInputAlert2: 'amount is necessary',
    wrongSumAlert: 'amount must be a multiple of 2500',
    notEnoughPointAlert: 'you have no enough points',
    textRqstSentToAdmin: 'Your request have been sent to admin',
  },
  de: {
    btnText: 'Tausch',
    labelWallet: 'Adresse der Brieftasche:',
    btnNextText: 'Nächste > ',
    inputPlaceholder: 'zum beispiel',
    emptyInputAlert: 'Adresse der Brieftasche ist erforderlich',
    labelSum: 'Geben Sie den umzutauschenden Betrag an',
    inputPlaceholder2: 'zum beispiel 2500, 5000 и т.д.',
    emptyInputAlert2: 'betrag ist erforderlich',
    wrongSumAlert: 'der Betrag muss ein Vielfaches von 2500 sein',
    notEnoughPointAlert: 'Sie haben nicht genug Punkte',
    textRqstSentToAdmin: 'Ihre Anfrage wurde an admin gesendet',
  },
};
